// Pure cross-type search over the already-fetched attribute types (no extra
// fetch — the dashboard already holds the full admin list via
// useGetAttributeTypesApi). Used by the screen to drive both the flat
// cross-type results panel and the rail's "matching type" highlight.

import type { AttributeTypeAdmin, AttributeValueAdmin } from 'apis/product-attributes';

export interface AttributeSearchHit {
  type: AttributeTypeAdmin;
  value: AttributeValueAdmin;
}

const matchesQuery = (value: AttributeValueAdmin, query: string): boolean => {
  if (value.value.toLowerCase().includes(query)) return true;
  if (value.label.toLowerCase().includes(query)) return true;
  return (value.synonyms ?? []).some((synonym) => synonym.toLowerCase().includes(query));
};

/**
 * Case-insensitive match over value/label/synonyms across ALL types.
 * Returns [] for a blank query (callers gate "isSearching" on the trimmed
 * query themselves, so this never has to guess intent).
 */
export function searchAttributeValues(types: AttributeTypeAdmin[], query: string): AttributeSearchHit[] {
  const q = query.trim().toLowerCase();
  if (!q) return [];

  const hits: AttributeSearchHit[] = [];
  for (const type of types) {
    for (const value of type.values) {
      if (matchesQuery(value, q)) hits.push({ type, value });
    }
  }
  return hits;
}
